import * as React from 'react'
import { Helmet } from 'react-helmet'

import { sanitizeCookie } from '@thg-commerce/enterprise-utils'
import { useSiteConfig, useSiteDefinition } from '@thg-commerce/enterprise-core'
import { COOKIE_GROUP_POWER_REVIEWS } from '@thg-commerce/enterprise-core/src/utils/CookieHelper/types'
import { ContentItem } from '../../Product'

export type PowerReviewProps = {
  sku: number
  externalId: number
  locale: string
  component?: PowerReviewComponentType
  id?: string
  pathname?: string
  powerReviewGroups?: string
}

export enum PowerReviewGroups {
  PROPERTY = 'reviewsGroupingId',
}

export enum PowerReviewComponentType {
  REVIEW_DISPLAY = 'ReviewDisplay',
  REVIEW_SNIPPET = 'ReviewSnippet',
  REVIEW_CATEGORY_SNIPPET = 'CategorySnippet',
  REVIEW_WRITE_REVIEW = 'Write',
}

enum PowerReviewStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

export function getPowerReviewGroups(content?: ContentItem[]) {
  const powerReviewGroupItem = content?.find(
    ({ key }) => key === PowerReviewGroups.PROPERTY,
  )
  if (powerReviewGroupItem) {
    const powerReviewGroupValue = powerReviewGroupItem.value as {
      __typename: 'ProductContentStringListValue'
      stringListValue: string[]
    }

    if (
      powerReviewGroupValue.stringListValue &&
      powerReviewGroupValue.stringListValue.length > 0
    ) {
      return powerReviewGroupValue.stringListValue[0]
    }
  }
  return
}

export const PowerReview = ({
  sku,
  externalId,
  locale,
  component,
  id,
  pathname,
  powerReviewGroups,
}: PowerReviewProps) => {
  const {
    powerReviewApiUrl,
    powerReviewApiKey,
    powerReviewMerchantGroupId,
    powerReviewMerchantId,
  } = useSiteConfig()
  const { domain } = useSiteDefinition()
  const cookieGroupPattern = new RegExp(
    `%2CC000${COOKIE_GROUP_POWER_REVIEWS}%2C`,
  )
  const sanitizedValue = sanitizeCookie('actualOptanonConsent')
  const powerReviewValidation = Boolean(cookieGroupPattern.test(sanitizedValue))
  const powerReviewStatus = powerReviewValidation
    ? PowerReviewStatus.ENABLED
    : PowerReviewStatus.DISABLED

  if (
    !powerReviewApiUrl ||
    !powerReviewApiKey ||
    !powerReviewMerchantGroupId ||
    !powerReviewMerchantId
  ) {
    return null
  }
  return (
    <React.Fragment>
      {/* TODO: add next/Head */}
      <Helmet>
        <script
          type="text/javascript"
          crossOrigin="anonymous"
          src={powerReviewApiUrl}
          defer
        />
        <script type="text/javascript" defer>{`
              window.pwr = window.pwr || function () {
                (pwr.q = pwr.q || []).push(arguments);
              };
              pwr("render", {
                api_key: '${powerReviewApiKey}',
                locale: '${locale}',
                merchant_group_id: '${powerReviewMerchantGroupId}',
                merchant_id: '${powerReviewMerchantId}',
                page_id: '${powerReviewGroups ?? externalId}',
                sm_data: '${powerReviewStatus}',
                enable_front_end_iovation_validation: ${powerReviewValidation},
                review_wrapper_url: "/addReview.account?pr_return_url=${domain}${pathname}&productId=${sku}&powerGroups=${powerReviewGroups}",
                components: {
                    ${component}: '${id}'
                }
              });
        `}</script>
      </Helmet>
      <div id={`${id}`}></div>
    </React.Fragment>
  )
}
